'use client';

import React from 'react';

interface BlogSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

export default function BlogSearchInput({ value, onChange, placeholder }: BlogSearchInputProps) {
  return (
    <label className="flex cursor-text items-center gap-[1.875rem] rounded-[4rem] bg-[rgba(217,217,217,0.38)] px-[3rem] py-[1.75rem] max-lg:w-full lg:w-[53.125rem] lg:shrink-0">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="h-[3rem] w-[3rem] shrink-0"
      >
        <path
          d="M21 21L15 15M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <input
        type="text"
        inputMode="search"
        enterKeyHint="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="w-full min-w-0 bg-transparent font-geist leading-normal tracking-[-0.08rem] text-black outline-none placeholder:text-black/60 max-lg:text-[length:max(2rem,16px)] lg:text-[2rem]"
      />
    </label>
  );
}
